import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, Apple, Heart, Book, CheckCircle } from 'lucide-react';
import './Inicio.css';
import videoLanding from '../../Images/video_landing.mp4';
import ServicesModal from '../../Body/ServicesModal/ServicesModal';

const Inicio = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="inicio-wrapper" id="inicio">
      {/* Hero Section */}
      <div className="hero-section">
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={videoLanding} type="video/mp4" />
          Tu navegador no soporta el tag de video.
        </video>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="hero-content"
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="promo-badge"
          >
            Planes personalizados para tus necesidades
          </motion.div>

          <h1 className="inicio-title">
            Nutricionista en Lima <br />
            <span className="highlight">Alcanza tus objetivos</span>
          </h1>

          <p className="inicio-description">
            Te ayudo a conseguir resultados duraderos a través de planes nutricionales
            personalizados y un acompañamiento profesional continuo.
          </p>

          <div className="buttons-container">
            <motion.button
              onClick={() => setIsModalOpen(true)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="primary-button"
            >
              <Calendar className="button-icon" />
              Agenda tu consulta
            </motion.button>
          </div>

        </motion.div>

        {/* Stats Section moved outside hero-content to have more space */}
        <motion.div
          className="stats-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <div className="stats-grid">
            {[
              { number: "5+", text: "Años de experiencia" },
              { number: "500+", text: "Pacientes satisfechos" },
              { number: "100%", text: "Personalizado" },
              { number: "24/7", text: "Seguimiento" }
            ].map((stat, index) => (
              <motion.div
                key={index}
                className="stat-card"
                whileHover={{ scale: 1.05 }}
              >
                <div className="stat-number">{stat.number}</div>
                <div className="stat-text">{stat.text}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* Benefits Section */}
      <motion.section
        className="benefits-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        <h2 className="benefits-title">Metodología de trabajo</h2>
        <div className="benefits-grid">
          {[
            {
              icon: Apple,
              title: "Evaluación Personalizada",
              text: "Análisis detallado de tu estado actual y objetivos específicos"
            },
            {
              icon: Heart,
              title: "Plan a tu Medida",
              text: "Estrategias nutricionales adaptadas a tu estilo de vida"
            },
            {
              icon: Book,
              title: "Educación y Guía",
              text: "Aprenderás a mantener hábitos saludables a largo plazo"
            },
            {
              icon: CheckCircle,
              title: "Seguimiento Continuo",
              text: "Soporte constante para asegurar tu progreso"
            }
          ].map((benefit, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              className="benefit-card"
            >
              <benefit.icon className="benefit-icon" />
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-text">{benefit.text}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>
      <AnimatePresence>
        {isModalOpen && (
          <ServicesModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default Inicio;